import { Select } from 'antd';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from 'react';
import useInpFiles from '../../hooks/useInpFiles';

type Props = {
  organizationId: number;
  onSelect: (value: any) => void;
  emitObject?: boolean;
  defaultValue?: any;
  locationId?: any;
  requireLocation?: boolean;
  onlyCompleted?: boolean | null;
  hasControlKpi?: boolean | null;
};

const SelectInpFile = forwardRef<any, Props>(
  (
    {
      organizationId,
      onSelect,
      emitObject = false,
      defaultValue = null,
      locationId = null,
      requireLocation = false,
      onlyCompleted = null,
      hasControlKpi = null,
    },
    ref,
  ) => {
    const [selectedValue, setSelectedValue] = useState<any>(null);
    const [displayName, setDisplayName] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>('');

    const debounceRef = useRef<number | null>(null);

    const { inpFiles, setParams } = useInpFiles({
      organizationId,
      locationId,
      size: 100,
      requireLocation,
      onlyCompleted,
      hasControlKpi,
      name: null,
    });

    useEffect(() => {
      console.log("🔍 Parámetros de búsqueda:", {
        organizationId,
        locationId,
        searchTerm,
        requireLocation,
        onlyCompleted,
        hasControlKpi,
      });
    }, [organizationId, locationId, searchTerm, requireLocation, onlyCompleted, hasControlKpi]);


    useEffect(() => {
      if (!selectedValue && defaultValue) {
        const findInitialDisplayName = () => {
          if (emitObject) {
            try {
              const defaultObj = typeof defaultValue === 'string'
                ? JSON.parse(defaultValue)
                : defaultValue;
              return inpFiles.find(f => f.inpId === defaultObj?.inpId)?.inpName;
            } catch {
              return null;
            }
          } else {
            return inpFiles.find(f => f.inpId == defaultValue)?.inpName;
          } 
        };

        const file = inpFiles.find(f => f.inpId == defaultValue);
        const name = file ? `${file.inpId} - ${file.inpName}` : null;

        if (name) {
          setDisplayName(name);
          setSelectedValue(defaultValue);
        }
      } else {
        const findDisplayName = () => {
          if (emitObject) {
            try {
              const selectedObj = typeof selectedValue === 'string'
                ? JSON.parse(selectedValue)
                : selectedValue;
              return inpFiles.find(f => f.inpId === selectedObj?.inpId)?.inpName;
            } catch {
              return null;
            }
          } else {
            const file = inpFiles.find(f => f.inpId == selectedValue);
            return file ? `${file.inpId}: ${file.inpName}` : null;
          }
        };

        setDisplayName(findDisplayName() || null);
      }
    }, [selectedValue, inpFiles, emitObject, defaultValue]);

    useImperativeHandle(ref, () => ({
      setValue: (value: any) => {
        setSelectedValue(value);
      },
    }));

    useEffect(() => {
      setParams((p: any) => ({ ...p, locationId }));
    }, [locationId, setParams]);

    useEffect(() => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      debounceRef.current = window.setTimeout(() => {
        if (searchTerm.length >= 2) {
          setParams((p: any) => ({ ...p, name: searchTerm, page: 1 }));
        } else {
          setParams((p: any) => ({ ...p, name: null, page: 1 }));
        }
      }, 500);

      return () => {
        if (debounceRef.current) {
          clearTimeout(debounceRef.current);
        }
      };
    }, [searchTerm, setParams]);

    const handleChange = (value: any) => {
      setSelectedValue(value);
      onSelect(parseInt(value));
    };


    return (
      <Select
        showSearch
        filterOption={false}
        placeholder="Select an option"
        value={
          selectedValue
            ? {
              value: selectedValue,
              label: displayName || '',
            }
            : undefined
        }
        style={{ width: '100%' }}
        onSearch={setSearchTerm}
        onChange={handleChange}
        notFoundContent={<span>No records found</span>}
        options={inpFiles.map((p: any) => ({
          value: emitObject ? JSON.stringify(p) : p.inpId,
          label: `${p.inpId} - ${p.inpName}`,
        }))}
      />
    );
  },
);

export default SelectInpFile;
